import React from "react";
import { ToolTip } from "@components/atoms/tooltip/tooltip";
import { HelpIconButton } from "@components/atoms/help-icon-button/help-icon-button";
import { useI18N } from "@src/language/language-context";

export interface HelpIconButtonPropTypes {
  isHelpIconActive: boolean;
  handleClick: () => void;
}

export const HelpIconButtonWrapperWithTooltip = ({
  isHelpIconActive,
  handleClick,
}: HelpIconButtonPropTypes) => {
  const i18n = useI18N();
  return (
    <>
      {!isHelpIconActive ? (
        <ToolTip
          position={"bottom"}
          content={i18n("modules.helpButton.tooltip")}
        >
          <HelpIconButton
            isIconActive={isHelpIconActive}
            handleClick={handleClick}
            iconName={"question_mark"}
          />
        </ToolTip>
      ) : (
        <HelpIconButton
          iconName={"question_mark"}
          isIconActive={isHelpIconActive}
          handleClick={handleClick}
        />
      )}
    </>
  );
};
